import { Icon } from "@minervaproject/fds";
import { forwardRef } from "react";

import { IconPropsType } from "shared/types";

const CaptionUnavailableIcon = forwardRef<HTMLElement, IconPropsType>((props, ref) => {
  return (
    <Icon {...props} ref={ref}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3307 2.66602L2.66406 29.3327"
          stroke={props?.color || "#000"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 7H4V24.6848H28V7Z"
          stroke={props?.color || "#000"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9563 19.5128C13.2897 19.7543 12.5849 19.872 11.8763 19.8601C11.3897 19.891 10.9024 19.8139 10.4488 19.6341C9.99531 19.4543 9.58678 19.1763 9.2523 18.8199C8.59175 17.9745 8.26678 16.913 8.3403 15.8408C8.32436 15.1043 8.47652 14.374 8.7851 13.7058C9.06252 13.1161 9.51391 12.6266 10.0779 12.3038C10.6798 11.9708 11.359 11.8043 12.0459 11.8215C12.8093 11.8139 13.5639 11.9863 14.2491 12.3247"
          stroke={props?.color || "#000"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.3598 19.5152C22.6931 19.7565 21.9884 19.8742 21.2798 19.8625C20.7933 19.8934 20.3059 19.8163 19.8524 19.6365C19.3988 19.4567 18.9903 19.1787 18.6558 18.8223C17.9979 17.9758 17.6748 16.9147 17.7486 15.8432C17.7327 15.1067 17.8848 14.3764 18.1934 13.7082C18.4681 13.1212 18.9147 12.6326 19.4734 12.3078C20.0774 11.9741 20.7588 11.8076 21.4478 11.8255C22.2118 11.8181 22.9668 11.9905 23.6526 12.3287"
          stroke={props?.color || "#000"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { CaptionUnavailableIcon };
